<template>
  <div id="app_signup">
    <vue-element-loading :active="appLoading" :is-full-screen="true" />
    <ServerError v-if="ServerError" />
    <v-layout wrap justify-space-around>
      <v-flex xs12 md12 pa-4>
        <v-card id="app_height" outlined>
          <v-layout pt-8 wrap justify-center>
            <v-flex xs12 sm2 md1 text-center>
              <v-btn x-large icon router-link to="/">
                <v-img src="../../assets/icons/back.png" aspect-ratio="1" contain height="400">
                  <template v-slot:placeholder>
                    <v-row class="fill-height ma-0" align="center" justify="center">
                      <v-progress-circular indeterminate color="#26af82"></v-progress-circular>
                    </v-row>
                  </template>
                </v-img>
              </v-btn>
            </v-flex>
            <v-flex xs12 md10 text-center align-self-end>
              <span class="login_head">Welcome to the Ecosystem Investment Platform</span>
            </v-flex>
            <v-flex xs12 sm2 md1></v-flex>
          </v-layout>
          <v-layout wrap>
            <v-flex text-center>
              <span
                style="font-size:12px;font-weight:400;color:#a9a9a9;"
              >You have signed in as Individual Investor</span>
            </v-flex>
          </v-layout>
          {{msg}}
          <profileDetails v-bind:profileDat="profileData" v-if="dataretrived" />
          <registrationDetails v-bind:profileDat="profileData" v-if="dataretrived" />
          <documentDetails v-bind:profileDat="profileData" v-if="dataretrived" />
        </v-card>
      </v-flex>
    </v-layout>
  </div>
</template>
<script>
import profileDetails from "./../Profile/profileDetails";
import registrationDetails from "./../Profile/registrationDetails";
import documentDetails from "./../Profile/documentDetails";
import axios from "axios";

export default {
  components: {
    profileDetails,
    registrationDetails,
    documentDetails
  },
  data() {
    return {
      winStep: 0,
      msg: null,
      profileData: {},
      appLoading: false,
      dataretrived: false,
      ServerError: false
    };
  },
  beforeMount() {
    this.getProfile();
  },
  methods: {
    winStepper(window_data) {
      this.winStep = window_data.winStep;
    },
    getProfile() {
      this.appLoading = true;
      axios({
        method: "GET",
        url: "/user/profile",
        headers: {
          "x-auth-token": localStorage.getItem("token")
        }
      })
        .then(response => {
          this.profileData = response.data.data;
          if (this.profileData.profilestep == 0) {
            this.$router.push("/CompleteProfile");
          } else if (this.profileData.profilestep == 1) {
            this.$router.push("/DocumentsUpload");
          } else if (this.profileData.profilestep == 2) {
            this.$router.push("/registrationAcknowledgement");
          } else {
            this.dataretrived = true;
          }
          this.appLoading = false;
        })
        .catch(err => {
          this.msg = err;
          this.ServerError = true;
        });
    }
  }
};
</script>
<style scoped>
#app_signup {
  background-image: url("../../assets/home_header.png");
  background-repeat: no-repeat;
  background-size: cover;
  color: white;
}
@media only screen and (min-width: 800px) {
  #app_height {
    min-height: 80vh;
  }
}
</style>